import { secureApiGet } from '../secureHttp';
import { Session } from '../../../types/session';
import { mapSessionResponse, RawSessionItem } from '../../../utils/sessionMapper';

export interface SessionsListResponse {
  data: Session[];
  total: number;
  metadata?: {
    total?: number;
    pages?: number;
    current_page?: number;
    per_page?: number;
    has_next_page?: boolean;
    has_prev_page?: boolean;
  };
}

export interface SessionsListQuery extends Record<string, unknown> {
  skip?: number;
  take?: number;
  page?: number;
  per_page?: number;
  process_id?: string;
  process?: string;
  psychologist_id?: string;
  status?: string;
  date?: string;
  date_from?: string;
  date_to?: string;
}

interface ApiCoreListResponse<T> {
  metadata?: {
    total?: number;
    pages?: number;
    current_page?: number;
    per_page?: number;
    has_next_page?: boolean;
    has_prev_page?: boolean;
  };
  results: T[];
}

export async function getSessions(params?: SessionsListQuery): Promise<SessionsListResponse> {
  const resp = await secureApiGet<ApiCoreListResponse<RawSessionItem>>('/v2/sessions', params);
  const items = Array.isArray(resp.results) ? resp.results : [];
  const data: Session[] = items.map(mapSessionResponse);
  const total = resp.metadata?.total ?? data.length;
  return { data, total, metadata: resp.metadata };
}


